import React, { useCallback, useMemo, useState } from 'react';
import AskRecordLauncherCard from './AskRecordLauncherCard';
import AskRecordSheet from './AskRecordSheet';
import { getFirstName } from './askRecordUi';

const AskRecordLauncher = ({
  child,
  accent,
  logCount = 0,
  onOpenSource,
  variant = 'default',
  sx,
}) => {
  const [open, setOpen] = useState(false);
  const [resultQuestion, setResultQuestion] = useState('');
  const [sheetSessionKey, setSheetSessionKey] = useState(0);
  const firstName = useMemo(() => getFirstName(child?.name), [child?.name]);
  const hasResult = Boolean(resultQuestion);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
    setResultQuestion('');
    setSheetSessionKey((currentKey) => currentKey + 1);
  }, []);

  const handleOpenSource = useCallback((source) => {
    onOpenSource?.(source);
    handleClose();
  }, [handleClose, onOpenSource]);

  const handleResultStateChange = useCallback((state) => {
    setResultQuestion(state?.hasResult ? state.question || '' : '');
  }, []);

  if (!child?.id) {
    return null;
  }

  return (
    <>
      <AskRecordLauncherCard
        firstName={firstName}
        logCount={logCount}
        onClick={handleOpen}
        variant={variant}
        accent={accent}
        sx={sx}
      />

      <AskRecordSheet
        accent={accent}
        child={child}
        firstName={firstName}
        hasResult={hasResult}
        logCount={logCount}
        onClose={handleClose}
        onOpenSource={handleOpenSource}
        onResultStateChange={handleResultStateChange}
        open={open}
        sessionKey={sheetSessionKey}
      />
    </>
  );
};

export default AskRecordLauncher;
